/** Statuses at which an orchestrator run has finished (successfully or otherwise). */
var TERMINAL_ORCHESTRATOR_STATUSES = ["completed", "failed", "request_failed", "timeout"];

/** True while an orchestrator run is in progress: a status is set and it is not terminal. */
export function isOrchestratorRunActive(status) {
  return status !== undefined && !TERMINAL_ORCHESTRATOR_STATUSES.includes(status);
}